import { render, staticRenderFns } from "./LegacyServerHostingFirewallService.vue?vue&type=template&id=111afe82&"
import script from "./LegacyServerHostingFirewallService.vue?vue&type=script&lang=js&"
export * from "./LegacyServerHostingFirewallService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports